export default __webpack_public_path__ + "static/media/bidvestinsurance.6a924d02.png";